"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textQuestionType = exports.silentRedirectUri = exports.silentRedirectPath = exports.redirectUri = exports.redirectPath = exports.ratingQuestionType = exports.multipleChoiceQuestionType = exports.URL_SETTINGS = exports.TEXT_QUESTION_RESPONSE_CHAR_LIMIT = exports.SUBMIT_BUTTON_PROPERTIES = exports.SIF_PROFILE_ID = exports.REQUIRED_QUESTION_TITLE = exports.PLACEHOLDERS = exports.GENERAL_FEEDBACK_QUESTIONS = exports.FEEDBACK_LINKS = exports.FEEDBACK_FORM_PROPERTIES = exports.CSAT_SURVEY_OPTIONAL_PAGE = exports.CSAT_SURVEY_MANDATORY_PAGE = exports.CSAT_SURVEY_FEEDBACKINTENT = exports.CSAT_SURVEY_APPLICATIONID_INTERNAL = exports.CSAT_SURVEY_APPLICATIONID_EXTERNAL = void 0;
var FEEDBACK_FORM_PROPERTIES = exports.FEEDBACK_FORM_PROPERTIES = {
  description: 'Thank you for taking time to fill in this feedback. This will not take more than 1 minute of your valuable time.',
  title: 'Feedback',
  confirmationMessage: 'Thank You! We appreciate your feedback.'
};
var REQUIRED_QUESTION_TITLE = exports.REQUIRED_QUESTION_TITLE = 'Please answer all required question';
var FEEDBACK_LINKS = exports.FEEDBACK_LINKS = {
  skip: 'Skip',
  submit: 'Submit Feedback'
};
var PLACEHOLDERS = exports.PLACEHOLDERS = {
  multipleChoiceQuestionType: 'Select an option',
  textQuestion: 'Enter your valuable suggestions'
};
var SUBMIT_BUTTON_PROPERTIES = exports.SUBMIT_BUTTON_PROPERTIES = {
  text: 'Submit',
  size: 'medium',
  type: 'primary'
};
var multipleChoiceQuestionType = exports.multipleChoiceQuestionType = {
  multipleChoiceQuestionType: {
    options: [{
      optionNumber: 1,
      optionValue: 'Labeling'
    }, {
      optionNumber: 2,
      optionValue: 'Tracking'
    }, {
      optionNumber: 3,
      optionValue: 'Others'
    }]
  }
};
var ratingQuestionType = exports.ratingQuestionType = {
  ratingQuestionType: {
    minRatingValue: 1,
    ratingInterval: 1,
    isVisualRatingType: true,
    numberOfIntervals: 5
  }
};
var textQuestionType = exports.textQuestionType = {
  textQuestionType: {
    wordLimit: 60
  }
};
var GENERAL_FEEDBACK_QUESTIONS = exports.GENERAL_FEEDBACK_QUESTIONS = [{
  questionText: 'Please select a functionality you would like to provide feedback',
  questionId: '88a2021e-b2de-4440-b1b3-2d914786aae4',
  isMandatory: true,
  questionType: multipleChoiceQuestionType
}, {
  questionText: 'How clearly does the interface communicate that it will help you complete the task that you wish to complete?',
  questionId: '6f799b02-0a6e-4b32-a759-3f677bba8bf0',
  isMandatory: true,
  questionType: ratingQuestionType
}, {
  questionText: 'Do you have any suggestions to improve your experience?',
  questionId: 'b0f3a7e8-94f7-409c-81aa-263f4189fd85',
  isMandatory: false,
  questionType: textQuestionType
}];

// This is a default limit if backend API has no char limit set
var TEXT_QUESTION_RESPONSE_CHAR_LIMIT = exports.TEXT_QUESTION_RESPONSE_CHAR_LIMIT = 1000;

// SIF profile ID
var SIF_PROFILE_ID = exports.SIF_PROFILE_ID = 'TCFA_Profile';

// CSAT survey feedback pages
var CSAT_SURVEY_MANDATORY_PAGE = exports.CSAT_SURVEY_MANDATORY_PAGE = 'csat_survey_mandatory_page';
var CSAT_SURVEY_OPTIONAL_PAGE = exports.CSAT_SURVEY_OPTIONAL_PAGE = 'csat_survey_optional_page';
var CSAT_SURVEY_FEEDBACKINTENT = exports.CSAT_SURVEY_FEEDBACKINTENT = 'survey';
var CSAT_SURVEY_APPLICATIONID_INTERNAL = exports.CSAT_SURVEY_APPLICATIONID_INTERNAL = 'Passport';
var CSAT_SURVEY_APPLICATIONID_EXTERNAL = exports.CSAT_SURVEY_APPLICATIONID_EXTERNAL = 'CarrierLogistics';
var URL_SETTINGS = exports.URL_SETTINGS = '/settings.json';
// Auth routes
var redirectPath = exports.redirectPath = '/auth';
var redirectUri = exports.redirectUri = "".concat(origin).concat(redirectPath);
var silentRedirectPath = exports.silentRedirectPath = '/auth-silent';
var silentRedirectUri = exports.silentRedirectUri = "".concat(origin).concat(silentRedirectPath);
//# sourceMappingURL=FeedbackConstants.js.map